import { window, document } from "global";
import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

interface PortalProps {
  children: React.ReactNode;
  dest?: string;
}

export default function Portal(props: PortalProps) {
  const el = useRef(document && document.createElement("div"));
  const { children, dest = "react-portal" } = props;

  useEffect(() => {
    document && document.getElementById(dest).appendChild(el.current);

    return () => {
      document && document.getElementById(dest).removeChild(el.current);
    };
  }, []);

  if (!window) {
    return null;
  }

  return createPortal(children, el.current);
}
